import api from './Api'

const route = '/organizacion'

export default {
  get: params => api().get(`${route}`, { params })
}
